import React from 'react';
import { getCategoryConfig } from '../utils/categoryConfig';
import './CategoryBadge.css';

const CategoryBadge = ({ category }) => {
  const config = getCategoryConfig(category);

  return (
    <span 
      className="category-badge"
      style={{
        backgroundColor: config.bgColor,
        color: config.color
      }}
    >
      <span className="category-icon">{config.icon}</span>
      <span className="category-label">{config.label}</span>
    </span>
  );
};

export default CategoryBadge;
